// Haut de page : le titre, et une grille d'aperçus qui change selon le public
// choisi (« Je m'entraîne » / « Je coache »). Les aperçus bouclent doucement.
import React, { useState } from "react";
import BoutonsStores from "../../site/BoutonsStores";
import { IconeEtoile } from "../../site/Icones";
import ApercuSerie from "../../site/apercus/ApercuSerie";
import ApercuCourbe1RM from "../../site/apercus/ApercuCourbe1RM";
import ApercuEleves from "../../site/apercus/ApercuEleves";
import ApercuConsigne from "../../site/apercus/ApercuConsigne";
import ApercuElevesActifs from "../../site/apercus/ApercuElevesActifs";
import { ApercuSemaine, ApercuNotificationProgrammation } from "../../site/apercus/ApercuPetitesCartes";

export default function Hero() {
	const [cible, setCible] = useState("sportif");

	return (
		<section className="gs-hero" aria-labelledby="gs-hero-titre">
			<div className="gs-quadrillage gs-quadrillage--hero" />
			<div className="gs-conteneur gs-hero-grille">
				<div className="gs-hero-texte">
					<span className="gs-surtitre">Carnet d'entraînement + coaching</span>
					<h1 id="gs-hero-titre" className="gs-h1">
						La <em className="gs-accent">progression</em> repensée.
						<br />
						Le <em className="gs-accent">coaching</em> simplifié.
					</h1>
					<p className="gs-texte gs-texte--grand">
						Note tes séances en deux minutes, vois chaque série progresser, et laisse Gym'Coach ou ton coach
						préparer la suivante.
					</p>
					<div className="gs-bascule" role="group" aria-label="Voir GymNote pour">
						<button type="button" aria-pressed={cible === "sportif"} onClick={() => setCible("sportif")}>
							Je m'entraîne
						</button>
						<button type="button" aria-pressed={cible === "coach"} onClick={() => setCible("coach")}>
							Je coache
						</button>
					</div>
					<BoutonsStores />
					<div className="gs-note-stores">
						<IconeEtoile />
						5/5 sur l'App Store et Google Play
					</div>
				</div>

				<div className="gs-hero-visuel">
					{cible === "sportif" ? (
						<div className="gs-bento" key="sportif">
							<ApercuSerie boucle className="gs-bento-l4" />
							<ApercuCourbe1RM boucle className="gs-bento-l2" />
							<ApercuSemaine boucle className="gs-bento-l2" />
							<ApercuNotificationProgrammation sombre className="gs-bento-pleine" />
						</div>
					) : (
						<div className="gs-bento" key="coach">
							<ApercuEleves boucle seule className="gs-bento-l5" />
							<ApercuElevesActifs className="gs-bento-l3" />
							<ApercuConsigne boucle compact className="gs-bento-l2" />
						</div>
					)}
				</div>
			</div>
		</section>
	);
}
